import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { RouterProvider, createBrowserRouter } from 'react-router-dom'
import { Main, Projects, SoloProject, Blogs } from './components/compIndex';

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      {
        path: '/',
        element: <Main />
      },
      {
        path: '/projects',
        element: <Projects />
      },
      {
        path: '/projects/:name',
        element: <SoloProject />
      }
      ,
      {
        path: '/blogs',
        element: <Blogs />
      }
    ]
  },

])

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
